import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';

const SelectBlankNotesModal = ({ onConfirm, onCancel }) => (
  <>
    <div className="modal-header">
      <h2 className="modal-title">Discard your messages and order all blank cards?</h2>
    </div>
    <div className="modal-body">
      <p className="text-left">Any thank you notes you’ve written will be permanently deleted.</p>
    </div>
    <div className="modal-footer">
      <div className="text-group row">
        <ButtonV2 onClick={onCancel} className="btn-left" variant="secondary">
          Cancel
        </ButtonV2>
        <ButtonV2 onClick={onConfirm} variant="danger" className="btn-right">
          Yes, Discard Messages
        </ButtonV2>
      </div>
    </div>
  </>
);

SelectBlankNotesModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: () => {
    dispatch(hideModal());
    if (ownProps.callback) ownProps.callback();
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(SelectBlankNotesModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/SelectBlankNotesModal.jsx